<template>
  <div class="g-page__row">
    <h3>{{ $t('createEnvelope.documentSelectionConfirmation.yourSelectedDocuments') }}</h3>
    <!--TODO replace with cards?-->
    <VDocumentListCollapsed :selected="$store.state.envelopes.creating.envelope.documents" />
  </div>
</template>

<script>
import VDocumentListCollapsed from '@/views/components/DocumentListCollapsed.vue';

export default {
  name: 'VDocumentSectionConfirmation',
  description: 'Used after step 1 to list the documents you\'re using',
  components: {
    VDocumentListCollapsed,
  },
};
</script>
